import type {ReactElement} from "react";
import {Chip, type ChipProps} from "@mui/material";
import VerifiedIcon from '~/icons/svg/VerifiedIcon.svg?react'
import ScheduleIcon from '~/icons/svg/ScheduleIcon.svg?react'
import WarningCircleIcon from '~/icons/svg/WarningCircleIcon.svg?react'
import InfoIcon from '~/icons/svg/InfoIcon.svg?react'

const ICON_SIZE = {width: 14, height: 14};

/**
 * `STATUS_CHIP[status]` is the ready-made chip for that status — same styling, label and icon
 * everywhere. Add a key here when a module needs a new status.
 */
export const STATUS_CHIP = {
    met: <Chip size="small" color="success" label="Met" icon={<VerifiedIcon {...ICON_SIZE}/>}/>,
    expiring: <Chip size="small" color="warning" label="Expiring" icon={<ScheduleIcon {...ICON_SIZE}/>}/>,
    expired: <Chip size="small" color="error" label="Expired" icon={<WarningCircleIcon {...ICON_SIZE}/>}/>,
    missing: <Chip size="small" color="error" label="Missing" icon={<WarningCircleIcon {...ICON_SIZE}/>}/>,
    pending: <Chip size="small" color="info" label="Pending" icon={<InfoIcon {...ICON_SIZE}/>}/>,
} satisfies Record<string, ReactElement<ChipProps>>;

export type StatusKey = keyof typeof STATUS_CHIP;
